import { render, staticRenderFns } from "./Professional.vue?vue&type=template&id=aa337ab8&scoped=true&"
import script from "./Professional.vue?vue&type=script&lang=js&"
export * from "./Professional.vue?vue&type=script&lang=js&"
import style0 from "./Professional.vue?vue&type=style&index=0&id=aa337ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa337ab8",
  null
  
)

export default component.exports